/* global $ */
/* global euAdminConfig */
import escape from 'lodash.escape';
import csv from '../modules/csv';
import usersImport from '../modules/users-import';
import dnsLookup from '../modules/dns-lookup';
import lookup from '../modules/lookup-result-handler';
import initReadmore from '../modules/readmore';
import getUserDetails from '../modules/user-details';
import respondToVisibility from '../modules/visibility';

const browseInputField = () => {
    let lines;
    let isValid;
    const fileLabel = $('#form-file-label');
    const importError = $('#importError');
    let fileName = null;

    $('#importUser').on('change', function () {
        $(this).removeClass('is-invalid');
        importError.hide();

        // get the file name
        fileName = $(this).val().split(/[\\\/]/);

        // replace the "Choose a file" label
        fileLabel.html(fileName[fileName.length - 1]);

        const csvInstance = new csv();
        csvInstance.handle(this.files[0], {
            0: 'user', 1: 'password', 2: 'forename', 3: 'surname'
        }, ',', (csvLines, isFileValid) => {
            lines = csvLines;
            isValid = isFileValid;
        });
    });

    $('#importBtn').on('click', function (e) {
        e.preventDefault();

        if (typeof isValid === 'undefined' && fileName) {
            return;
        }

        if (!isValid) {
            $('#importUser').focus();
            $('#importUser').addClass('is-invalid');

            importError.show();

            return;
        }

        let createdUsers = [];
        let failedUsers = [];
        const statuses = $(this).data('statuses');
        const defaultPop3Label = $(this).data('defaultPop3Label');

        const importInfo = $('#importInfo');
        importInfo.show();
        importInfo.find('.max').text(lines.length);
        importInfo.find('.imported').text(0);
        importInfo.find('.failed').text(0);

        const usersImportInstance = new usersImport();
        usersImportInstance.import(lines, 2, (response) => {
            if (response === 'fail') {
                window.location.replace(`${euAdminConfig.base_uri + euAdminConfig.hostname}/users`);
            }

            const created = typeof response.created === 'object' ? Object.values(response.created) : response.created;
            const failed = typeof response.failed === 'object' ? Object.values(response.failed) : response.failed;

            importInfo.find('.imported').text(
                parseInt(importInfo.find('.imported').text()) + created.length
            );

            importInfo.find('.failed').text(
                parseInt(importInfo.find('.failed').text()) + failed.length
            );

            createdUsers = created.concat(createdUsers);
            failedUsers = failed.concat(failedUsers);
        }, () => {
            let errorMessage = '';
            let successMessage = '';
            const alert = $('#alert-box');
            const usersTable = $('#usersTable');
            const maxMailCountElement = $('.mail-max');
            const activeMailCountElement = $('.mail-count');

            alert.empty();

            failedUsers.forEach((userData, key) => {
                errorMessage += `<li><span class="fa-li"><i class="fa fa-minus-circle text-danger"></i></span>${escape(userData.message)}</li>`;
            });

            if (errorMessage) {
                const html = '<div class="alert alert-danger alert-dismissible alert-flash fade show" role="alert">'
                    + '           <div class="readmore-box">'
                    + `             <ul class="fa-ul">${errorMessage}</ul>`
                    + '             <p class="readmore-shadow"><a href="#" class="readmore-btn"></a></p>'
                    + '           </div>'
                    + '           <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>'
                    + '         </div>';
                alert.append(html);
            }

            createdUsers.forEach((userData, key) => {
                let fullname = userData.user.forename
                    ? userData.user.forename.charAt(0).toUpperCase() + userData.user.forename.slice(1)
                    : userData.user.user.charAt(0).toUpperCase() + userData.user.user.slice(1);
                fullname += ' ';
                fullname += userData.user.surname
                    ? userData.user.surname.charAt(0).toUpperCase() + userData.user.surname.slice(1)
                    : `@${euAdminConfig.hostname}`;
                fullname += ' (new)';

                const tableHtml = `<a href="${(`${euAdminConfig.base_uri + euAdminConfig.hostname}/users/${escape(userData.user.id)}/edit`)}" class="ftable-row ftable-row-link table-user-row ftable-5cols">`
                    + '           <div class="ftable-cell ftable-user-cell text-start">'
                    + '             <div class="profile-picture">'
                    + `               <span class="profile-no-picture">${escape(fullname.charAt(0).toUpperCase())}</span>`
                    + '               <i class="fa fa-pencil" aria-hidden="true"></i>'
                    + '             </div>'

                    + `             <span class="profile-name d-none d-sm-inline-block text-truncate">${
                        fullname
                    }             </span>`
                    + '           </div>'

                    + '           <div class="ftable-cell ftable-email-cell text-start">'
                    + '             <div class="profile-picture">'
                    + '               <i class="fa fa-pencil" aria-hidden="true"></i>'
                    + '             </div>'

                    + '             <div class="text-truncate">'
                    + `               <b>${escape(userData.user.user)}@${escape(euAdminConfig.hostname)}</b>`
                    + '             </div>'
                    + '           </div>'

                    + '           <div class="ftable-cell ftable-subscription-cell text-start">'
                    + `             <div class="content-status ${escape(statuses[userData.user.status].class)} d-block">`
                    + `               <span class="d-inline">${escape(statuses[userData.user.status].label)}</span>`
                    + '             </div>'
                    + '           </div>'

                    + '           <div class="ftable-cell ftable-pop-cell text-center">'
                    + '             <div class="content-status text-danger d-block">'
                    + `               <span class="d-inline">${escape(defaultPop3Label)}</span>`
                    + '             </div>'
                    + '           </div>'

                    + '           <div class="ftable-cell ftable-usage-cell text-end">'
                    + '             <div class="progress-container">'
                    + '               <div class="small-text d-none d-sm-block">0% of 20 GB</div>'
                    + '               <div class="small-text d-sm-none d-xs-block">0%</div>'
                    + '               <div class="progress-bar">'
                    + '                 <div class="progress-status" style="width: 0"></div>'
                    + '               </div>'
                    + '             </div>'
                    + '           </div>'
                    + '         </a>';

                usersTable.append(tableHtml);

                successMessage += `<li><span class="fa-li"><i class="fa fa-check text-success"></i></span>${escape(userData.message)}</li>`;

                if (userData.user.status === 'open') {
                    activeMailCountElement.text(parseInt(activeMailCountElement.first().text()) + 1);
                }
                maxMailCountElement.text(parseInt(maxMailCountElement.first().text()) + 1);
            });

            if (successMessage) {
                const html = '<div class="alert alert-success alert-dismissible alert-flash fade show" role="alert">'
                    + '           <div class="readmore-box">'
                    + `             <ul class="fa-ul">${successMessage}</ul>`
                    + '             <p class="readmore-shadow"><a href="#" class="readmore-btn"></a></p>'
                    + '           </div>'
                    + '           <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>'
                    + '         </div>';

                alert.append(html);
            }

            $('#userImportModal').modal('hide');
            $('#importForm')[0].reset();
            importInfo.hide();
            fileLabel.html(fileLabel.data('label'));
            createdUsers = [];
            failedUsers = [];
        });
    });
};

const initialize = () => {
    if ($('#pageUser').data('domainStatus') == 1) {
        browseInputField();
        initReadmore();

        const emails = $('.profile-email');
        emails.each((index, emailElement) => {
            respondToVisibility(emailElement, (visible) => {
                if (visible && emailElement.dataset.processed === 'false') {
                    const username = emailElement.dataset.profileUsername;
                    const userStatus = emailElement.dataset.profileStatus;

                    getUserDetails(username, userStatus, (data) => {
                        if (data) {
                            if (data.forwards && data.forwards.length && emailElement.dataset.profileStatus !== 'closed') {
                                const forwardIconId = `${username}forward`;

                                const forward = $(`span[id="${forwardIconId}"]`);
                                forward.removeClass('d-none');
                                forward.attr('title', `${forward.attr('title')} (${data.forwards})`);
                            }

                            let used = 0;
                            let total = 107374182400;
                            if (data.quota) {
                                used = data.quota.used;
                                total = data.quota.total;
                            }

                            //temp convert until prefs moved to bytes
                            let totalGigabytes = total / 1024 / 1024 / 1024;
                            if (total.toString().length < 11) {
                                totalGigabytes = total / 1000 / 1000;
                            }
                            //round to whole number
                            totalGigabytes = Math.round(totalGigabytes);

                            const usedPercentage = Math.round((used / total) * 100);

                            let quotaColorStatus = 'blue';
                            if (usedPercentage >= 50 && usedPercentage < 90) {
                                quotaColorStatus = 'yellow';
                            } else if (usedPercentage >= 90) {
                                quotaColorStatus = 'red';
                            }

                            document.querySelector(`[data-row-username="${username}"] .progress-container`).innerHTML = `
                                <div class="small-text
                                    d-none d-sm-block">
                                    ${usedPercentage}% of ${totalGigabytes}GB
                                </div>
                                <div class="small-text
                                    d-sm-none d-xs-block">
                                    ${usedPercentage}%
                                </div>
                                <div class="progress-bar d-none d-sm-block">
                                    <div class="progress-status progress-status-${quotaColorStatus}" style="width: ${usedPercentage}%${usedPercentage === 0 ? ';border-left:none' : ''}"></div>
                                </div>
                            `;
                        }

                        emailElement.dataset.processed = true;
                    });
                }
            });
        });
    } else {
        const dnsLookupInstance = new dnsLookup();

        lookup(dnsLookupInstance, 'ownership_txt');
    }
};

export default initialize;
